import * as Effect from "effect/Effect";
import * as Layer from "effect/Layer";
import * as Headers from "effect/unstable/http/Headers";

import { LOCAL_HOST_SESSION_HEADER } from "./localHostSession.ts";

export const httpHeaderRedactionLayer = Layer.effect(
  Headers.CurrentRedactedNames,
  Effect.map(Headers.CurrentRedactedNames, (names) => [
    ...names,
    ...(names.includes(LOCAL_HOST_SESSION_HEADER) ? [] : [LOCAL_HOST_SESSION_HEADER]),
    ...(names.includes("sec-websocket-protocol") ? [] : ["sec-websocket-protocol"]),
  ]),
);
